// used to hardcode override values for local development
// also used to prevent reloading of a flag from remote changes
// example:
export default {
  // 'NameOfFlag': true|false,
  // 'feature_LEARN-27700_specialized-lesson-completion-updates': true,
}
